var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedChevronUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34916 1.09925L1.14166 5.30675C0.78416 5.66425 0.78416 6.24175 1.14166 6.59925C1.49916 6.95675 2.07666 6.95675 2.43416 6.59925L5.99999 3.04258L9.55666 6.59925C9.91416 6.95675 10.4917 6.95675 10.8492 6.59925C11.2067 6.24175 11.2067 5.66425 10.8492 5.30675L6.64166 1.09925C6.29333 0.74175 5.70666 0.74175 5.34916 1.09925Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedChevronUpIcon);
export default __webpack_public_path__ + "static/media/DeprecatedChevronUpIcon.ab183771f993dc28962f7f84c0a3fd3a.svg";
export { ForwardRef as ReactComponent };